import axios from 'axios';
import { API_URLS } from '../urls';
import { BackendResponse, handleError } from '../../dataTypes/backendServicesManagment/types';
import { Keyword, initializedKeyword } from '../../dataTypes/keywordManagment/types';

export interface BackendResponse_Keyword extends BackendResponse<Keyword[]> {}

// Fonction pour récupérer les mots-clés
export const getKeywords = async (): Promise<BackendResponse_Keyword> => {
  const url = API_URLS.getKeywords;

  try {
    const response = await axios.get(url);

    if (response.status === 200) {
      const keywords: Keyword[] = response.data['hydra:member'].map((keyword: any) => {
        const defaultKeyword = initializedKeyword();
        return {
          ...defaultKeyword,
          id: keyword.id ?? defaultKeyword.id,
          word: keyword.word ?? defaultKeyword.word,
        };
      });

      return {
        code: 1,
        comment: 'The retrieval of keywords is complete.',
        payload: keywords,
      };
    } else {
      return handleError<Keyword[]>(response.status, 'Non-200 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<Keyword[]>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<Keyword[]>(-102, 'Unknown error');
  }
};

// Fonction pour créer un mot-clé
export const createKeyword = async (word: string): Promise<BackendResponse> => {
  const url = `${API_URLS.createKeyword}`;

  try {
    const response = await axios.post(url, { word }, {
      headers: { 'Accept': 'application/ld+json', 'Content-Type': 'application/ld+json' },
    });

    console.log (">>>>>>>>>>>>>>>>>>>>>>>>createKeyword", response)

    if (response.status === 201) {
      return {
        code: 1,
        comment: 'Keyword created successfully',
        payload: response.data.id,
      };
    } else {
      return handleError<void>(response.status, 'Error creating the keyword');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error occurred');
  }
};

// Fonction pour supprimer un mot-clé
export const deleteKeyword = async (id: number): Promise<BackendResponse> => {
  const url = `${API_URLS.deleteKeyword}`.replace('{id}', `${id}`);

  try {
    const response = await axios.delete(url);

    if (response.status === 204) {
      return {
        code: 1,
        comment: 'Keyword successfully deleted.',
        payload: {} as any,
      };
    } else {
      return handleError<void>(-103, `Error deleting the keyword : ${response.status}`);
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error');
  }
};
